import React from 'react';
import { useSelector } from 'react-redux';
import { formatPower } from '../public/formatPower';
import '../routes/pvstatus/MainCenterGaugeChart.css';
import './IvCurrentPowerPanel.css';

function IvCurrentPowerPanel() {
  // 리덕스에서 인버터 리스트와 실시간 데이터 가져오기
  const Iv_list = useSelector((state) => state.Iv_list || {});
  const ivData = useSelector((state) => state.ivData || {});

  const names = Iv_list.iv_name || [];   // 인버터 이름 배열 (없으면 비어있음)
  const capaArr = Iv_list.iv_capa || []; // 정격용량(kW) 배열
  const gridArr = Array.isArray(ivData.Grid_Power)
    ? ivData.Grid_Power
    : [];

  // 최대 길이 기준으로 행 만들기
  const rowCount = Math.max(names.length, gridArr.length, capaArr.length);

  const rows = [];
  for (let i = 0; i < rowCount; i += 1) {
    const name = names[i] || `PVIV-${i + 1}`;
    const nowPowerW = gridArr[i] != null ? Number(gridArr[i]) : 0; // 단위: W 가정
    const capaKw = capaArr[i] != null ? Number(capaArr[i]) : 0;    // 단위: kW

    // 표시용 문자열 (formatPower는 기존 함수 재사용)
    const powerFormatted = formatPower(nowPowerW, 'Real'); // {value, unit} 객체 반환

    rows.push({
      id: i,
      name,
      value: powerFormatted.value,
      unit: powerFormatted.unit,
      capaKw,
    });
  }

  return (
    <div className='chart-container'>
      <div className='gauge-chart-container'>
        {/* 제목박스 */}
        <div className='gauge-chart-topbox' style={{ borderBottom: '2px solid #DCE0EB' }}>
          <div>{'◎ 개별 인버터 출력 정보'}</div>
          <div style={{ flexGrow: '1' }}></div>
          <div style={{ marginLeft: "20px" }}>⦁ ⦁ ⦁</div>
        </div>
        {/* 본문박스 - 게이지 차트와 동일한 높이로 고정 */}
        <div className='gauge-chart-midbox' style={{ 
          borderBottomLeftRadius: '5px', 
          borderBottomRightRadius: '5px',
          height: '400px' // 게이지 차트의 midbox + bottombox 높이와 동일하게 고정
        }}>
          <div className='iv-current-body'>
            {rows.map((row) => (
              <div className="iv-current-row" key={row.id}>
                <div className="iv-current-name">
                  {row.name}
                </div>
                <div className="iv-current-value-wrapper">
                  <span className="iv-current-value">{row.value}</span>
                  <span className="iv-current-unit">{row.unit}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default IvCurrentPowerPanel;